module.exports = __webpack_public_path__ + "img/fireRed.13b6ef68.svg";